module.exports = __webpack_public_path__ + "static/img-iphone-reporting@3x.3b3eb1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-iphone-reporting@3x.png
// module id = 794
// module chunks = 173911521112049